module.exports = __webpack_public_path__ + "img/canceled_stamp.f3eb8f22.jpg";